/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'

export default {
  fetchUsers ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/usuarios')
        .then((response) => {
          commit('SET_USERS', response.data['hydra:member'])
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUser (context, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/usuarios/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getSupervisores ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/usuarios?roles=ROLE_SUPERVISOR')
        .then((response) => {
          commit('setSupervisoresMutation', response.data['hydra:member'])
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addUser ({ commit }, usuario) {
    return new Promise((resolve, reject) => {
      axios.post('/api/usuarios', usuario)
        .then((response) => {
          commit('ADD_USER', Object.assign(usuario, { id: response.data.id }))
          resolve(response.data)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  updateUser ({ commit }, userData) {
    return new Promise((resolve, reject) => {
      axios.patch(`/api/usuarios/${userData.id}`, userData, { headers: {'Content-Type': 'application/merge-patch+json'} })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeUser ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/usuarios/${userId}`)
        .then((response) => {
          commit('REMOVE_USER', userId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
